import { createSlice } from "@reduxjs/toolkit";

export const itemDetailsSlice = createSlice({
    name: 'itemDetails',
    initialState: {
        item: null,
    },
    reducers: {
        setItem: (state, action) => {
            state.item = action.payload;
        },
        addActionToItem: (state, action) => {
            const { itemId, actionName } = action.payload;

            // const item = state.items.find(i => i.id === itemId);
            if (state.item && state.item?.id === itemId) {
                const actionStat = state.item.actionStats.find(as => as.action === actionName);
                if (actionStat) {
                    actionStat.count++;
                } else {
                    state.item.actionStats.push({ action: actionName, count: 1 });
                }
                if (!state.item.actions.includes(actionName)) {
                    state.item.actions.push(actionName);
                }
            }
        },
    },
});

export const { setItem, addActionToItem } = itemDetailsSlice.actions;
export default itemDetailsSlice.reducer;